module.exports = __webpack_public_path__ + "img/Finale-Screens-web.cff62a41.png";